import { io } from "socket.io-client";
import { ipUrl } from "../Config/url";
const socket = io(ipUrl);
export default socket;